export const formatDate = (time, format) => {
    let date = time;
    var o = {
        'M+': date.getMonth() + 1, //month
        'd+': date.getDate(), //day
        'H+': date.getHours(), //hour+8小时
        'm+': date.getMinutes(), //minute
        's+': date.getSeconds(), //second
        'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
        'S': date.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format))
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));

    for (var k in o)
        if (new RegExp('(' + k + ')').test(format))
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return format;
}
export const getHistoryHourTime = (date, hour) => {
    return new Date(date.getTime() - hour * 60 * 60 * 1000)
}

export const getNow = () => {
    return formatDate(new Date(), 'yyyy-MM-ddTHH:mm:ss');
}

export const getTimeByPattern = (format) => {
    //
    return formatDate(new Date(), format)
}

export const parseDate = (timeLong) => {
    if (timeLong) {
        return formatDate(new Date(timeLong), 'yyyy-MM-dd HH:mm:ss');
    } else {
        return ''
    }
}
//
// /**
//  * @param {number} time
//  * @param {string} option
//  * @returns {string}
//  */
// export function formatTime(time, option) {
//     if (('' + time).length === 10) {
//         time = parseInt(time) * 1000
//     } else {
//         time = +time
//     }
//     const d = new Date(time)
//     const now = Date.now()
//
//     const diff = (now - d) / 1000
//
//     if (diff < 30) {
//         return '刚刚'
//     } else if (diff < 3600) {
//         // less 1 hour
//         return Math.ceil(diff / 60) + '分钟前'
//     } else if (diff < 3600 * 24) {
//         return Math.ceil(diff / 3600) + '小时前'
//     } else if (diff < 3600 * 24 * 2) {
//         return '1天前'
//     }
//     if (option) {
//         return parseTime(time, option)
//     } else {
//         return (
//             d.getMonth() +
//             1 +
//             '月' +
//             d.getDate() +
//             '日' +
//             d.getHours() +
//             '时' +
//             d.getMinutes() +
//             '分'
//         )
//     }
// }

export const getUserName = () => {

    return sessionStorage.getItem('staff') ? JSON.parse(sessionStorage.getItem('staff')).name : ''
}
export const getUserId = () => {

    return sessionStorage.getItem('staff') ? JSON.parse(sessionStorage.getItem('staff')).id : ''
}


export function deepClone(obj) {
    const _toString = Object.prototype.toString

    // null, undefined, non-object, function
    if (!obj || typeof obj !== 'object') {
        return obj
    }

    // DOM Node
    if (obj.nodeType && 'cloneNode' in obj) {
        return obj.cloneNode(true)
    }

    // Date
    if (_toString.call(obj) === '[object Date]') {
        return new Date(obj.getTime())
    }

    // RegExp
    if (_toString.call(obj) === '[object RegExp]') {
        const flags = []
        if (obj.global) {
            flags.push('g')
        }
        if (obj.multiline) {
            flags.push('m')
        }
        if (obj.ignoreCase) {
            flags.push('i')
        }

        return new RegExp(obj.source, flags.join(''))
    }

    const result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {}

    for (const key in obj) {
        result[key] = deepClone(obj[key])
    }

    return result
}

export const listToMap = (list, keyName) => {
    let map = new Map()
    if (list.map) {
        list.map(item => {
            if (item[keyName] != null) {
                map.set(item[keyName], item)
            }
        })
        return map
    }
    return {}
}

export const _strMapToObj = (strMap) => {
    let obj = Object.create(null);
    for (let [k, v] of strMap) {
        obj[k] = v;
    }
    return obj;
}
/**
 *map转换为json
 */
export const mapToJson = (map) => {
    return JSON.stringify(_strMapToObj(map));
}
